import * as React from "react";
import * as ReactDOM from "react-dom";
import {connect} from "react-redux";
import GameplayMap from "./map/GameplayMap";
import * as _ from "lodash";
import {MODALS} from "../../../store/reducers/modal";
import {POPUPS} from "../../../store/reducers/popup";
import EventDetails from "./modals/event-details/EventDetails";
import {IScreenComponentProps, screenComponent} from "../screenComponent";
import PowerSources from "./power-sources/PowerSources";
import PowerSourceDetails from "./modals/power-source-details/PowerSourceDetails";
import AddPowerSource from "./popups/add-power-source/AddPowerSource";
import Hint from "./modals/hint/Hint";
import OutageQuestion from "./modals/event-question/OutageQuestion";
import Outage from "./modals/outage/Outage";
import ModalComponent from "./modals/ModalComponent";
import {setScreen, showMainMenu} from "../../../store/actions/screens";
import {SCREENS} from "../../../store/reducers/screen";
import GameOver from "./modals/game-over/GameOver";
import TimerStart from "./modals/timer-start/TimerStart";
import {startTimer} from "../../../store/actions/timer";
import {isDragging} from "../../../store/reducers/interaction";
import TimeManager from "./timer/TimeManager";
import GameUi from "./game-ui/GameUi";
import DraggablePowerSource from "./power-sources/DraggablePowerSource";
import {showNextOutageQuestion, showNextYearEndQuestion} from "../../../store/actions/questions/questions";
import YearInfo from './modals/year-info/YearInfo';
import YearEndQuestion from './modals/event-question/YearEndQuestion';
import HintsButton from './hints-button/HintsButton';
import {activateMiniGame} from '../../../store/actions/mini-game/miniGame';
import {getMiniGameID, hasMiniGameData} from '../../../store/reducers/mini-game/miniGame';

interface IGameProps extends IScreenComponentProps
{
    is_dragging: boolean;
    has_mini_game: boolean;
    is_already_complete: boolean;
    startTimer: () => void;
    showQuestion: () => void;
    activateMiniGame: () => void;
    showEventGame: () => void;
    showMainMenu: () => void;
    showYearEndQuestion: () => void;
}

import './Game.scss';
import Clouds from './map/Clouds';
import QuitButton from './hints-button/QuitButton';
import GameCalendar from './timer/GameCalendar';
import YearEnd from "./modals/year-end/YearEnd";
import {isYearAlreadyComplete} from '../../../store/reducers/calendar/isYearAlreadyComplete';

class Game extends React.Component<IGameProps, null>
{
    constructor(public props: IGameProps)
    {
        super(props);
    }


    startMiniGame = () =>
    {
        const {has_mini_game} = this.props;

        if (! has_mini_game) return;

        this.props.showEventGame();
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {active, is_dragging, showQuestion} = this.props;

        if (! active) return null;

        return <div styleName={! is_dragging ? 'game' : 'dragging'}>

            <GameplayMap />

            <Clouds />

            <PowerSources />

            <DraggablePowerSource />

            <GameUi />

            <div styleName={'top-right-ui'}>

                {/*<div
                    styleName={'edf-logo'}>

                    <img src="./img/main-menu/edf-logo.png" />

                </div>*/}

                {/*<HintsButton />*/}

                <QuitButton />

                <GameCalendar />

            </div>



            {/*<AddPowerSource popup_id={POPUPS.ADD_POWER_SOURCE}/>*/}

            <ModalComponent
                modal_id={MODALS.TIMER_START}
                onClose={this.props.startTimer}>

                <TimerStart/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.HINT}
                close_button_type={'none'}>

                <Hint/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.OUTAGE}
                onClose={showQuestion}>

                <Outage/>

            </ModalComponent>

            {/*<ModalComponent modal_id={MODALS.SEASON}>

                <SeasonInfo/>

            </ModalComponent>*/}

            <ModalComponent
                modal_id={MODALS.YEAR}
                close_button_type={this.props.is_already_complete ? 'none' : 'slideshow-complete'}
                close_button_text={"let's go!"}
                onClose={this.startMiniGame}>

                <YearInfo/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.YEAR_END_STATUS}
                close_button_type={'ok'}
                onClose={this.props.showYearEndQuestion}>

                <YearEnd/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.OUTAGE_QUESTION}
                close_button_type={'none'}>

                <OutageQuestion/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.YEAR_END_QUESTION}
                close_button_type={'none'}>

                <YearEndQuestion/>

            </ModalComponent>
{/*
            <ModalComponent
                modal_id={MODALS.EVENT}
                onClose={this.props.showEventGame}
                close_button_text={'start'}>

                <EventDetails/>

            </ModalComponent>*/}

            <ModalComponent
                modal_id={MODALS.POWER_SOURCE_DETAILS}
                close_button_type={'none'}>

                <PowerSourceDetails/>

            </ModalComponent>

            <ModalComponent
                modal_id={MODALS.GAME_OVER}
                close_button_type={'none'}>

                <GameOver/>

            </ModalComponent>

        </div>
    }
}


/**
 * map the state to props
 * @param state
 */
const mapStateToProps = state =>
{
    return {
        is_dragging: isDragging(state),
        has_mini_game: hasMiniGameData(state),
        is_already_complete: isYearAlreadyComplete(state),
    }
};


/**
 * map dispatch functions to the component props
 * @param dispatch
 * @returns {{onModeSelect: ((mode: string) => any); onCountrySelect: ((country: string) => any)}}
 */
const mapDispatchToProps = dispatch =>
{
    return {
        startTimer: () => dispatch(startTimer()),
        activateMiniGame: () => dispatch(activateMiniGame()),
        showEventGame: () => dispatch(setScreen(SCREENS.MINI_GAME)),
        showQuestion: () => dispatch(showNextOutageQuestion('low-energy-mix')),
        showMainMenu: () => dispatch(showMainMenu()),
        showYearEndQuestion: () => dispatch(showNextYearEndQuestion()),
    }
};


export default screenComponent()(connect(mapStateToProps, mapDispatchToProps)(Game));



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/Game.tsx